import api from "@helpers/api";

const UPLOAD_URL = `${process.env.REACT_APP_DOCUMENT_SERVICE_URL}${process.env.REACT_APP_DOCUMENT_SERVICE_PORT}/${process.env.REACT_APP_DOCUMENT_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/document`;

export const fileUpload = (() => {
  var config = {
    onUploadProgress: function (progressEvent: any) {
      var percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      );
      console.log(percentCompleted);
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return async (document: File): Promise<{ data: any }> => {
    const formData = new FormData();
    formData.append("file", document);
    formData.append("docType", "2");
    return api.post(UPLOAD_URL, formData, config).then((response) => {
      return { data: response.data };
    });
  };
})();
